import { render, staticRenderFns } from "./OnboardingSoftwareMFA.vue?vue&type=template&id=4ca33a3b"
import script from "./OnboardingSoftwareMFA.vue?vue&type=script&lang=js"
export * from "./OnboardingSoftwareMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports